<div class="restore-password-container">
  <h3>Restore Password</h3>
  <form [formGroup]="restoreForm" (ngSubmit)="submit()">
    <div class="p-fluid">
      <div class="p-field">
        <label for="email">Email</label>
        <input pInputText id="email" type="email" formControlName="email" />
        <small *ngIf="restoreForm.get('email')?.invalid && restoreForm.get('email')?.touched" class="p-error"> Enter a valid email </small>
      </div>
    </div>
    <div class="p-dialog-footer">
      <p-button label="Cancel" styleClass="p-button-text" (click)="close()"></p-button>
      <p-button label="Restore" type="submit" [disabled]="restoreForm.invalid"></p-button>
    </div>
  </form>
</div>
